import { useEffect } from "react";

function resolveUserSteamId(user, catalogUser) {
    return (
        user?.steamId ||
        user?.steamId64 ||
        user?.steam64Id ||
        catalogUser?.steamId ||
        catalogUser?.steamId64 ||
        catalogUser?.steam64Id ||
        null
    );
}

export default function useGlobalFriendRequests({
    actions,
    isAuthenticated,
    user,
    catalogUser,
}) {
    const resolvedUserSteamId = resolveUserSteamId(user, catalogUser);

    useEffect(() => {
        if (!isAuthenticated || !user || !resolvedUserSteamId) {
            return;
        }

        actions.initFriendRequests(resolvedUserSteamId);
    }, [actions, isAuthenticated, resolvedUserSteamId, user]);

    useEffect(() => {
        if (!isAuthenticated || !user || !resolvedUserSteamId) {
            return undefined;
        }

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                actions.initFriendRequests(resolvedUserSteamId);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [actions, isAuthenticated, resolvedUserSteamId, user]);
}
